<div class="rp">
  <div class="rp__card">

    @if (loading()) {
      <p class="rp__loading">{{ 'REGISTRATION_PENDING.LOADING' | translate }}</p>
    }

    @if (!loading() && registration(); as reg) {

      <span class="rp__icon" [ngClass]="'rp__icon--' + reg.status" aria-hidden="true">
        <i class="fa-solid"
           [ngClass]="reg.status === 'rejected' ? 'fa-circle-exclamation'
                    : reg.status === 'awaiting_review' ? 'fa-hourglass-half'
                    : 'fa-file-invoice-dollar'"></i>
      </span>

      <h1 class="rp__title">{{ 'REGISTRATION_PENDING.TITLE' | translate }}</h1>

      <p class="rp__status" [ngClass]="'rp__status--' + reg.status">
        {{ statusKey | translate }}
      </p>

      <p class="rp__lead">
        {{ (reg.status === 'rejected' ? 'REGISTRATION_PENDING.LEAD_REJECTED'
           : reg.status === 'awaiting_review' ? 'REGISTRATION_PENDING.LEAD_REVIEW'
           : 'REGISTRATION_PENDING.LEAD_PENDING') | translate }}
      </p>

      @if (reg.status === 'rejected' && reg.rejectionReason) {
        <p class="rp__reason">
          <strong>{{ 'REGISTRATION_PENDING.REASON' | translate }}</strong>
          {{ reg.rejectionReason }}
        </p>
      }

      <!-- Ce que l'élève a demandé : il doit pouvoir vérifier avant de payer. -->
      <dl class="rp__facts">
        <div class="rp__fact">
          <dt>{{ 'REGISTRATION_PENDING.REFERENCE' | translate }}</dt>
          <dd><code>{{ reg.reference }}</code></dd>
        </div>
        <div class="rp__fact">
          <dt>{{ 'REGISTRATION_PENDING.PACK' | translate }}</dt>
          <dd>{{ reg.packNameFr }}</dd>
        </div>
        <div class="rp__fact">
          <dt>{{ 'REGISTRATION_PENDING.PATH' | translate }}</dt>
          <dd>{{ reg.learningPathTitle }}</dd>
        </div>
        <div class="rp__fact">
          <dt>{{ 'REGISTRATION_PENDING.SUBJECTS' | translate }}</dt>
          <dd>{{ reg.subjects.join(' · ') }}</dd>
        </div>
        <div class="rp__fact rp__fact--amount">
          <dt>{{ 'REGISTRATION_PENDING.AMOUNT' | translate }}</dt>
          <dd>{{ reg.amountComputed }} {{ reg.currency }}</dd>
        </div>
      </dl>

      <!-- Où verser : sans ces coordonnées, « effectuez le virement » ne dit
           pas où. Elles viennent de l'administration, pas d'un texte figé. -->
      @if (canSubmitProof() && paymentMethods().length > 0) {
        <section class="rp__pay">
          <h2 class="rp__pay-title">{{ 'REGISTRATION_PENDING.PAY_TITLE' | translate }}</h2>

          @for (method of paymentMethods(); track method.id) {
            <article class="rp__pay-card">
              <header class="rp__pay-head">
                <i class="fa-solid fa-building-columns" aria-hidden="true"></i>
                <span>{{ label(method) }}</span>
              </header>

              @if (instructions(method); as text) {
                <p class="rp__pay-instructions">{{ text }}</p>
              }

              @if (method.kind === 'bank_transfer') {
                <dl class="rp__pay-fields">
                  @if (method.accountHolder) {
                    <div>
                      <dt>{{ 'REGISTRATION_PENDING.PAY_HOLDER' | translate }}</dt>
                      <dd>{{ method.accountHolder }}</dd>
                    </div>
                  }
                  @if (method.bankName) {
                    <div>
                      <dt>{{ 'REGISTRATION_PENDING.PAY_BANK' | translate }}</dt>
                      <dd>{{ method.bankName }}</dd>
                    </div>
                  }
                  @if (method.rib) {
                    <div>
                      <dt>{{ 'REGISTRATION_PENDING.PAY_RIB' | translate }}</dt>
                      <!-- Un RIB se lit de gauche à droite, même en arabe. -->
                      <dd dir="ltr">{{ method.rib }}</dd>
                    </div>
                  }
                  @if (method.iban) {
                    <div>
                      <dt>{{ 'REGISTRATION_PENDING.PAY_IBAN' | translate }}</dt>
                      <dd dir="ltr">{{ method.iban }}</dd>
                    </div>
                  }
                  @if (method.bic) {
                    <div>
                      <dt>{{ 'REGISTRATION_PENDING.PAY_BIC' | translate }}</dt>
                      <dd dir="ltr">{{ method.bic }}</dd>
                    </div>
                  }
                </dl>
              }

              <p class="rp__pay-ref">
                {{ 'REGISTRATION_PENDING.PAY_REFERENCE' | translate }}
                <strong>{{ reg.reference }}</strong>
              </p>
            </article>
          }
        </section>
      }

      @if (canSubmitProof()) {
        <div class="rp__upload">
          <h2 class="rp__upload-title">
            {{ (hasProof() ? 'REGISTRATION_PENDING.REPLACE_PROOF'
                           : 'REGISTRATION_PENDING.ADD_PROOF') | translate }}
          </h2>
          <p class="rp__upload-hint">{{ 'REGISTRATION_PENDING.PROOF_HINT' | translate }}</p>

          @if (hasProof()) {
            <p class="rp__proof-current">
              <i class="fa-solid fa-paperclip"></i>
              {{ reg.proofOriginalFileName }}
              <span class="rp__proof-date">{{ reg.proofSubmittedAt | localizedDate: 'short' }}</span>
            </p>
          }

          <label class="rp__btn rp__btn--primary" [class.rp__btn--busy]="uploading()">
            <i class="fa-solid fa-upload"></i>
            {{ (uploading() ? 'REGISTRATION_PENDING.UPLOADING'
                            : 'REGISTRATION_PENDING.CHOOSE_FILE') | translate }}
            <input type="file" accept="image/*,application/pdf" hidden
                   [disabled]="uploading()" (change)="onFileSelected($event)" />
          </label>

          @if (uploading() && progress() !== null) {
            <div class="rp__progress" role="progressbar"
                 [attr.aria-valuenow]="progress()" aria-valuemin="0" aria-valuemax="100">
              <span class="rp__progress-bar" [style.inline-size.%]="progress()"></span>
            </div>
          }

          @if (error()) {
            <p class="rp__error">{{ error() }}</p>
          }
        </div>
      }

      <div class="rp__actions">
        <button type="button" class="rp__btn" (click)="refresh()" [disabled]="uploading()">
          <i class="fa-solid fa-rotate-right"></i>
          {{ 'REGISTRATION_PENDING.REFRESH' | translate }}
        </button>
        <button type="button" class="rp__btn" (click)="logout()">
          <i class="fa-solid fa-arrow-right-from-bracket"></i>
          {{ 'REGISTRATION_PENDING.LOGOUT' | translate }}
        </button>
      </div>

    }
  </div>
</div>
